// file: src/app/pipes/space-thousands.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceThousands'
})
export class SpaceThousandsPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null || isNaN(Number(value))) {
      return ''; // handle null/undefined/non-number gracefully
    }

    const numberValue = Number(value);
    
    // Format number with space as thousand separator
    return numberValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
